import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    component: () => import('@/views/index'),
    meta: {
      title: '电工证报名',
      showTab: true
    }
  },

  // {
  // 	path: '/',
  // 	name: 'Index',
  // 	component: () => import('@/views/index'),
  // 	meta: {
  // 		title: '',
  // 		showTab: true
  // 	}
  // },
  {
    path: '/sign',
    component: () => import('@/views/sign'),
    meta: {
      title: '个人承诺书',
      showTab: true,
      hide: true
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/home'),
    meta: {
      title: '电工证报名',
      showTab: true
    }
  },
  {
    path: '/apply',
    name: 'Apply',
    component: () => import('@/views/apply'),
    meta: {
      title: '电工证报名',
      showTab: true
    }
  },
  {
    path: '/form',
    name: 'Form',
    component: () => import('@/views/form'),
    meta: {
      title: '电工证报名',
      showTab: true,
      hide: true
    }
  },
  {
    path: '/successfully',
    name: 'Successfully',
    component: () => import('@/views/successfully'),
    meta: {
      title: '电工证报名',
      showTab: true
    }
  },
  {
    path: '/realName',
    name: 'RealName',
    component: () => import('@/views/realName'),
    meta: {
      title: '电工证报名',
      hide: true
    }
  },
  {
    path: '/education',
    name: 'Education',
    component: () => import('@/views/education'),
    meta: {
      title: '电工证报名',
      hide: true
    }
  },
  {
    path: '/oneSize',
    component: () => import('@/views/oneSize'),
    meta: {
      title: '电工证报名',
      theme: 'theme_1',
      hide: true
    }
  },
  {
    path: '/photo',
    component: () => import('@/views/photo'),
    meta: {
      title: '电工证报名'
    }
  },
  {
    path: '/downLoadForIos',
    component: () => import('@/views/downLoadForIos'),
    meta: {
      title: '电工证报名'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login'),
    meta: {
      title: '手机快捷登录'
    }
  },
  {
    path: '/teacher',
    name: 'Teacher',
    component: () => import('@/views/login/teacher'),
    meta: {
      title: '辅导老师登录',
      leftArrow: false
    }
  },
  {
    path: '/signList',
    component: () => import('@/views/signList'),
    meta: {
      title: '报名记录'

    }
  },
  {
    path: '/submitPage',
    component: () => import('@/views/submitPage'),
    meta: {
      title: '信息确认',
      hide: true
    }
  },
  {
    path: '/aliPay',
    component: () => import('@/views/aliPay'),
    meta: {
      title: '支付宝支付'
    }
  }, {
    path: '/recruit',
    component: () => import('@/views/recruit'),
    meta: {
      title: '辅导老师招募',
      hide: true
    }
  }, {
    path: '/extend',
    component: () => import('@/views/recruit/extend'),
    meta: {
      title: '辅导老师招募',
      hide: true
    }
  }, {
    path: '/recruit_success',
    component: () => import('@/views/recruit/success'),
    meta: {
      title: '注册成功',
      hide: true
    }
  }, {
    path: '/agreement',
    component: () => import('@/views/recruit/agreement'),
    meta: {
      title: 'e电工辅导老师协议'
    }
  }, {
    path: '/tutoring',
    component: () => import('@/views/tutoring'),
    meta: {
      title: 'e电工云课堂辅导老师',
      theme: 'theme_1',
      leftArrow: false
    }
  },
  {
    path: '/promotion',
    component: () => import('@/views/promotion'),
    meta: {
      title: '推广',
      theme: 'theme_1'
    }
  },

  {
    path: '/tutoring_detail',
    component: () => import('@/views/tutoring/detail'),
    meta: {
      title: 'e电工云课堂辅导老师',
      theme: 'theme_1'
    }
  }, {
    path: '/tutoring_order',
    component: () => import('@/views/tutoring/order'),
    meta: {
      title: '返佣订单',
      theme: 'theme_1'
    }
  }, {
    path: '/tutoring_next',
    component: () => import('@/views/tutoring/next'),
    meta: {
      title: '下级辅导老师',
      theme: 'theme_1'
    }
  }, {
    path: '/',
    component: () => import('@/views/tutoring/sign'),
    meta: {
      title: 'e电工云课堂',
      theme: 'theme_1',
      leftArrow: false
    }
  }, {
    path: '/tutoring_assemble',
    component: () => import('@/views/tutoring/assemble'),
    meta: {
      title: 'e电工云课堂',
      theme: 'theme_1'
    }
  }, {
    path: '/tutoring_success',
    component: () => import('@/views/tutoring/success'),
    meta: {
      title: 'e电工云课堂',
      theme: 'theme_1'
    }
  }, {
    path: '/tutoring_signList',
    component: () => import('@/views/tutoring/signList'),
    meta: {
      title: '报名记录',
      theme: 'theme_1'
    }
  }, {
    path: '/tutoring_institution',
    component: () => import('@/views/tutoring/institution'),
    meta: {
      title: '实操培训机构',
      theme: 'theme_2'
    }
  }, {
    path: '/tutoring_cooperation',
    component: () => import('@/views/tutoring/next'),
    meta: {
      title: '签约机构',
      theme: 'theme_1'
    }
  }, {
    path: '/tutoring_withdraw',
    component: () => import('@/views/tutoring/withdraw'),
    meta: {
      title: '提现',
      theme: 'theme_1'
    }

  }, {
    path: '/tutoring_withdraw_success',
    component: () => import('@/views/tutoring/withdraw_success'),
    meta: {
      title: '提现',
      theme: 'theme_1'
    }

  },
  {
    path: '/student',
    component: () => import('@/views/student'),
    meta: {
      title: '学员管理',
      theme: 'theme_1'
    }
  },
  {
    path: '/make',
    component: () => import('@/views/make'),
    meta: {
      title: '',
      theme: 'theme_1'
    }
  },
  {
    path: '/sms',
    component: () => import('@/views/student/sms'),
    meta: {
      title: '发短信',
      theme: 'theme_2'
    }
  },
  {
    path: '/template',
    component: () => import('@/views/student/sms/template'),
    meta: {
      title: '选择模板',
      theme: 'theme_2'
    }
  },
  {
    path: '/fillIn',
    component: () => import('@/views/student/sms/template/fillIn.vue'),
    meta: {
      title: '填充模板',
      theme: 'theme_2'
    }
  },
  {
    path: '/history',
    component: () => import('@/views/student/sms/template/history.vue'),
    meta: {
      title: '发送记录',
      theme: 'theme_2'
    }
  }
]

const router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes
})

export default router
